import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WizardStatus } from '@app/_models/wizard/wizard-item.model';
import { StepperHelper } from '@app/_shared/helpers/StepperHelper';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GetStepsList } from '../../store/stepper.actions';
import { StepperState } from '../../store/stepper.state';
import { environment } from '@env/environment.local';
import { TranslateService } from '@ngx-translate/core';
import { SidebarState } from '@app/core/sidebar/store/sidebar.state';
import { InitialInfo } from '@app/_interfaces';

@Component({
    selector: 'welcome-wizard',
    templateUrl: './welcome-wizard.component.html',
    styleUrls: ['./welcome-wizard.component.scss'],
})
export class WelcomeWizardComponent implements OnInit {
    @Output() newEvent = new EventEmitter<any>();
    @Input() textButton: string;
    @Input() title: string;
    assetsUrl: string = environment.assets_url;
    mfsPath: string = environment.mfs_path;
    flagIa: boolean = false;
    iaDisabled: boolean = false;

    @Select(StepperState.getStepperGeneralStatus)
    stepperGeneralStatusResponse$: Observable<WizardStatus>;

    @Select(SidebarState.initialInfo)
    initialInfo$: Observable<InitialInfo>;

    constructor(public translate: TranslateService, private store: Store, private stepperHelper: StepperHelper) {
        const initialInfo = this.store.selectSnapshot(SidebarState.initialInfo);
        this.flagIa = initialInfo.data?.services.some((service) => service.name === 'ia_wizard_generation');
        this.iaDisabled = initialInfo.data?.services.some(
            (service) => service.name === 'ia_wizard_generation' && service.available === false
        );
    }

    ngOnInit(): void {
        if (this.flagIa) {
            this.store.dispatch(new GetStepsList('wizard-ia'));
        } else {
            this.rememberStatus();
            this.store.dispatch(new GetStepsList('wizard-inicial'));
        }
    }

    selectPath(path) {
        if (path == 'ia') {
            this.stepperHelper.setCurrentStepName('create-site');
            this.rememberStatus();
        } else {
            this.store.dispatch(new GetStepsList('wizard-inicial'));
            this.rememberStatus();
        }
    }

    emitEvent() {
        this.newEvent.emit();
    }

    rememberStatus() {
        this.stepperGeneralStatusResponse$.subscribe((status) => {
            this.stepperHelper.setGeneralStepperData(status.data ?? []);
            this.stepperHelper.setCurrentStepName(status.latestStepName ?? 'select-vertical');
            this.stepperHelper.setCurrentStepIndex(status.latestStepIndex ?? 0);
            this.emitEvent();
        });
    }
}
